const base = {
    //url公共参数，appName、token
    commParams:{

    },
    appName:'com.markingZXS.app',
}

export default base;